<template>
  <div class="m-2 flex w-max max-w-[90vw] space-x-2 bg-black p-2 text-white">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span v-html="alert.message" />
    <template v-for="action in alert.actions">
      <AgsLink
        v-if="action.href"
        :key="`link-${action.text}`"
        :class="action.class || ''"
        :to="action.href"
        raw
        class="underline"
        @click="onClick($event, action)"
      >
        {{ action.text }}
      </AgsLink>
    </template>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ alert: Alert }>()

const { $alert } = useNuxtApp()

const close = () => $alert.close(props.alert.id)

const onClick = (event: Event, action: ActionHandler) => {
  if (!action?.onClick) {
    return
  }
  event.preventDefault()
  event.stopImmediatePropagation()
  action?.onClick(event, { ...props.alert, close })
}
let timeout: NodeJS.Timeout

onMounted(() => {
  timeout = setTimeout(() => close(), props.alert.duration || 100000)
})

onUnmounted(() => timeout && clearTimeout(timeout))

defineOptions({ name: 'AppToast' })
</script>
